export default "__VITE_ASSET__3edf6999__"